import { render, staticRenderFns } from "./footerC.vue?vue&type=template&id=311c6002&scoped=true&"
import script from "./footerC.vue?vue&type=script&lang=js&"
export * from "./footerC.vue?vue&type=script&lang=js&"
import style0 from "./footerC.vue?vue&type=style&index=0&id=311c6002&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311c6002",
  null
  
)

export default component.exports